// // src/pages/TermsPage.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { ChevronDownIcon } from "@heroicons/react/24/outline";

// // Small helper for an accessible accordion item
// function AccordionItem({ id, title, children, isOpen, onToggle }) {
//   return (
//     <div className="rounded-lg border border-slate-200 bg-white">
//       <button
//         aria-expanded={isOpen}
//         aria-controls={`panel-${id}`}
//         onClick={onToggle}
//         className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
//       >
//         <span className="text-[15px] font-medium text-slate-800">{title}</span>
//         <ChevronDownIcon
//           className={`h-5 w-5 text-slate-500 transition-transform ${
//             isOpen ? "rotate-180" : ""
//           }`}
//         />
//       </button>
//       <div
//         id={`panel-${id}`}
//         role="region"
//         aria-labelledby={`btn-${id}`}
//         className={`px-4 pb-5 text-sm leading-6 text-slate-700 ${
//           isOpen ? "block" : "hidden"
//         }`}
//       >
//         {children}
//       </div>
//     </div>
//   );
// }

// export default function TermsPage() {
//   const sections = useMemo(
//     () => [
//       {
//         id: "acceptance",
//         title: "Acceptance of terms",
//         body: (
//           <>
//             <p>
//               By accessing or using ShowTimeBro (the “Website” and “Service”),
//               you agree to be bound by these Terms & Conditions and our Privacy
//               Policy. If you do not agree, please do not use the Service.
//             </p>
//             <p className="mt-2">
//               You represent that you are legally capable of entering into a
//               binding agreement and are at least 18 years of age (or using the
//               Service with the consent of a parent/guardian).
//             </p>
//           </>
//         ),
//       },
//       {
//         id: "modification",
//         title: "Modification of terms",
//         body: (
//           <p>
//             We may update these Terms from time to time. Changes become
//             effective when posted on this page. Your continued use after changes
//             are posted constitutes acceptance of the updated Terms.
//           </p>
//         ),
//       },
//       {
//         id: "privacy",
//         title: "Privacy policy",
//         body: (
//           <>
//             <p>
//               Please review our Privacy Policy to understand how we collect,
//               use, and safeguard your information. By using the Service, you
//               consent to the practices described there.
//             </p>
//             <p className="mt-2">
//               For questions or concerns, you can write to our Grievance Officer
//               at <a className="text-amber-600 underline" href="mailto:support@smtlabs.io">support@smtlabs.io</a>.
//             </p>
//           </>
//         ),
//       },
//       {
//         id: "limited-user",
//         title: "Limited user",
//         body: (
//           <p>
//             You agree to use the Service only for lawful purposes and in a way
//             that does not infringe the rights of, restrict, or inhibit anyone
//             else’s use and enjoyment of the Service. Automated scraping, bulk
//             data extraction, or reverse engineering is prohibited.
//           </p>
//         ),
//       },
//       {
//         id: "disclaimer",
//         title: "Disclaimer of warranties / Limitation of liability",
//         body: (
//           <>
//             <p>
//               The Service is provided on an “as is” and “as available” basis
//               without warranties of any kind, express or implied. To the
//               fullest extent permitted by law, ShowTimeBro disclaims all
//               warranties and shall not be liable for any indirect, incidental,
//               special, consequential, or exemplary damages arising from your use
//               of the Service.
//             </p>
//             <p className="mt-2">
//               In jurisdictions that do not allow certain disclaimers, our
//               liability shall be limited to the maximum extent permitted by law.
//             </p>
//           </>
//         ),
//       },
//       {
//         id: "third-party",
//         title: "Links to third-party sites",
//         body: (
//           <p>
//             The Website may contain links to third-party websites or services.
//             We do not control and are not responsible for the content, privacy
//             policies, or practices of any third parties. Accessing them is at
//             your own risk.
//           </p>
//         ),
//       },
//       {
//         id: "prohibited-use",
//         title: "Prohibition against unlawful use",
//         body: (
//           <ul className="list-disc pl-6 space-y-1">
//             <li>Attempting unauthorized access to any portion of the Service</li>
//             <li>Interfering with security features or network operations</li>
//             <li>Posting or transmitting harmful, fraudulent, or infringing content</li>
//             <li>Circumventing ticket purchase limits or anti-bot measures</li>
//           </ul>
//         ),
//       },
//       {
//         id: "communication",
//         title: "Use of communication services",
//         body: (
//           <p>
//             Where the Service offers chat, reviews, or community features, you
//             agree to post content that is respectful, lawful, and relevant. We
//             may monitor or remove content at our discretion to keep the platform
//             safe for all users.
//           </p>
//         ),
//       },
//       {
//         id: "termination",
//         title: "Termination / Access restriction",
//         body: (
//           <p>
//             We reserve the right to suspend or terminate your access to the
//             Service at any time, with or without notice, for conduct that we
//             believe violates these Terms or is otherwise harmful to the Service
//             or other users.
//           </p>
//         ),
//       },
//       {
//         id: "tickets-payments",
//         title: "Tickets, pricing & payments",
//         body: (
//           <>
//             <p>
//               All ticket prices, fees, and taxes are shown at checkout.
//               Confirmed orders are subject to venue and organizer rules. Unless
//               explicitly stated, tickets are non-refundable and non-transferable.
//             </p>
//             <p className="mt-2">
//               Payment processing is handled by trusted gateways. In case of
//               failed transactions with successful debits, refunds (if any) are
//               issued by the payment provider per their timelines.
//             </p>
//           </>
//         ),
//       },
//       {
//         id: "governing-law",
//         title: "Governing law & jurisdiction",
//         body: (
//           <p>
//             These Terms are governed by the laws of India. Courts at Indore,
//             Madhya Pradesh, shall have exclusive jurisdiction over disputes
//             arising from or relating to the Service.
//           </p>
//         ),
//       },
//       {
//         id: "contact",
//         title: "Contact & grievance",
//         body: (
//           <>
//             <p>
//               For support or grievances, contact our Grievance Officer:
//               <br />
//               <span className="font-medium">Email:</span>{" "}
//               <a className="text-amber-600 underline" href="mailto:support@smtlabs.io">
//                 support@smtlabs.io
//               </a>
//             </p>
//             <p className="mt-2">
//               We aim to acknowledge complaints within 48 hours and resolve them
//               at the earliest possible.
//             </p>
//           </>
//         ),
//       },
//     ],
//     []
//   );

//   // open one by hash (#privacy etc.)
//   const [openId, setOpenId] = useState(null);
//   useEffect(() => {
//     const fromHash = window.location.hash?.replace("#", "");
//     if (fromHash) setOpenId(fromHash);
//   }, []);

//   return (
//     <main className="min-h-screen bg-slate-50">
//       {/* Header */}
//       <div className="border-b border-slate-200 bg-white">
//         <div className="mx-auto max-w-6xl px-4 py-8">
//           <h1 className="text-2xl font-semibold text-slate-900">Terms and Conditions</h1>
//           {/* <p className="mt-1 text-sm text-slate-600">
//             Last updated on {new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
//           </p> */}
//         </div>
//       </div>

//       {/* Content */}
//       <div className="mx-auto max-w-6xl px-4 py-8">
//         {/* <div className="mb-4 flex flex-wrap items-center gap-3">
//           <button
//             onClick={() => setOpenId("__all__")}
//             className="rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white hover:bg-slate-800"
//           >
//             Expand all
//           </button>
//           <button
//             onClick={() => setOpenId(null)}
//             className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50"
//           >
//             Collapse all
//           </button>
//         </div> */}

//         <div className="space-y-3">
//           {sections.map((s) => {
//             const isOpen = openId === "__all__" || openId === s.id;
//             return (
//               <AccordionItem
//                 key={s.id}
//                 id={s.id}
//                 title={s.title}
//                 isOpen={isOpen}
//                 onToggle={() => setOpenId(isOpen ? null : s.id)}
//               >
//                 {s.body}
//               </AccordionItem>
//             );
//           })}
//         </div>

//         <p className="mt-8 text-xs text-slate-500">
//           Note: This page is a general template. Organizer/venue-specific terms may
//           apply in addition to the above. In case of conflict, organizer/venue
//           rules will prevail for their respective events.
//         </p>
//       </div>
//     </main>
//   );
// }



// src/pages/TermsOfUsePage.jsx
import React, { useEffect, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function AccordionItem({ id, title, children, isOpen, onToggle }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white">
      <button
        aria-expanded={isOpen}
        aria-controls={`panel-${id}`}
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
      >
        <span className="text-[15px] font-medium text-slate-800">{title}</span>
        <ChevronDownIcon
          className={`h-5 w-5 text-slate-500 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        id={`panel-${id}`}
        role="region"
        aria-labelledby={`btn-${id}`}
        className={`px-4 pb-5 text-sm leading-6 text-slate-700 ${
          isOpen ? "block" : "hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );
}

export default function TermsOfUsePage() {
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    const fromHash = window.location.hash?.replace("#", "");
    if (fromHash) setOpenId(fromHash);
  }, []);

  return (
    <main className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-8">
          <h1 className="text-2xl font-semibold text-slate-900">Terms of Use</h1>
          <p className="mt-1 text-sm text-slate-600">Last updated on Nov 25 2025</p>
        </div>
      </div>

      {/* Content */}
      <div className="mx-auto max-w-6xl px-4 py-8 space-y-3">

        <AccordionItem
          id="acceptance"
          title="Acceptance of Terms"
          isOpen={openId === null || openId === "acceptance"}
          onToggle={() => setOpenId(openId === "acceptance" ? null : "acceptance")}
        >
          <p>
            By accessing or using ShowTimeBro, you agree to be bound by these Terms
            of Use and all related policies. If you do not agree, you must stop
            using the service immediately.
          </p>
        </AccordionItem>

        <AccordionItem
          id="use"
          title="Permitted Use"
          isOpen={openId === "use"}
          onToggle={() => setOpenId(openId === "use" ? null : "use")}
        >
          <ul className="list-disc pl-6 space-y-1">
            <li>Use the platform legally and responsibly.</li>
            <li>Do not use bots, automation tools, or scraping methods.</li>
            <li>Do not attempt unauthorized access to any part of the platform.</li>
            <li>Do not interfere with platform security or operations.</li>
          </ul>
        </AccordionItem>

        <AccordionItem
          id="accounts"
          title="User Accounts & Responsibilities"
          isOpen={openId === "accounts"}
          onToggle={() => setOpenId(openId === "accounts" ? null : "accounts")}
        >
          <p>
            You are responsible for keeping your login details confidential and for
            all activities carried out through your account. Report any unauthorized
            activity immediately.
          </p>
        </AccordionItem>

        <AccordionItem
          id="payments"
          title="Payments, Bookings & Confirmations"
          isOpen={openId === "payments"}
          onToggle={() => setOpenId(openId === "payments" ? null : "payments")}
        >
          <p>
            All payments are securely handled by trusted payment gateways. A booking
            is considered confirmed only after successful payment. Any failed payment
            disputes must be taken up with your payment provider.
          </p>
        </AccordionItem>

        <AccordionItem
          id="liability"
          title="Limitation of Liability"
          isOpen={openId === "liability"}
          onToggle={() => setOpenId(openId === "liability" ? null : "liability")}
        >
          <p>
            ShowTimeBro is not responsible for event cancellations, delays, venue
            changes, or organizer decisions. Our liability is limited strictly to the
            value of services purchased through our platform.
          </p>
        </AccordionItem>

        <AccordionItem
          id="modifications"
          title="Changes to Terms"
          isOpen={openId === "modifications"}
          onToggle={() => setOpenId(openId === "modifications" ? null : "modifications")}
        >
          <p>
            ShowTimeBro may update these Terms of Use at any time. Continued use of
            the platform after changes means you accept the updated terms.
          </p>
        </AccordionItem>

        <AccordionItem
          id="contact"
          title="Contact & Support"
          isOpen={openId === "contact"}
          onToggle={() => setOpenId(openId === "contact" ? null : "contact")}
        >
          <p>If you need clarification regarding these Terms, contact:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li><strong>Email:</strong> info@showtimebro.com</li>
            <li><strong>Phone / WhatsApp:</strong> 7440550105</li>
          </ul>
        </AccordionItem>

      </div>
    </main>
  );
}
